import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Cross } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import { getTemplateConfigResponse } from '../../../extra-actions';
import {
  SupportedAiModelsOutput,
  SupportedAiModelsOutputColumnType,
} from '../enums';
import { ExistingPromptModalProps } from '../type';

const ExistingPromptModal: React.FC<ExistingPromptModalProps> = ({
  show,
  onClose,
  tempId,
  setEnrichPromptData,
  setError,
  setOriginalData,
}) => {
  const dispatch = useDispatch();

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="existing-prompt-modal"
      backdrop="static"
      centered
    >
      <div className="existing-prompt-modal-container">
        <div className="existing-prompt-modal-body">
          <div className="existing-prompt-modal-title">
            <span>Existing Prompt Detected</span>
            <div
              className="cross-icon-container"
              {...accessibleOnClick(onClose)}
            >
              <Cross width={16} height={16} className="cross-icon" />
            </div>
          </div>
          <div className="existing-prompt-modal-content">
            <span>
              This column already has a prompt configuration. Creating a new
              prompt will overwrite the existing one. Would you like to proceed
              with the existing one or create new one ?
            </span>
          </div>
        </div>
        <div className="divider-line" />
      </div>
      <div className="existing-prompt-modal-footer">
        <div
          className="create-new-button"
          {...accessibleOnClick(() => {
            onClose();
            setEnrichPromptData((prev) => ({
              ...prev,
              instructions: '',
              aiModelId: '1',
              customOutputFormatInput: '',
              selectedType: SupportedAiModelsOutputColumnType.PlainText,
              selectedOutputFormat: SupportedAiModelsOutput.Default,
              isWebSearchEnabled: false,
              isAutoRunEnabled: false,
              autoRunConditions: null,
            }));
            setOriginalData({
              aiModelId: 1,
              instructions: '',
              selectedOutputFormat: SupportedAiModelsOutput?.Default,
              isWebSearchEnabled: false,
              isAutoRunEnabled: false,
              autoRunConditions: null,
            });
            setError((prev) => ({
              ...prev,
              message: '',
              error: false,
            }));
          })}
        >
          Create New
        </div>
        <div className="save-prompt-btn">
          <Button
            {...accessibleOnClick(() => {
              dispatch(getTemplateConfigResponse(tempId));
              onClose();
            })}
          >
            Use Existing
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExistingPromptModal;
